/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./notifications-list-page.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "../notifications-list-iframe/notifications-list-iframe.component.ngfactory";
import * as i3 from "../notifications-list-iframe/notifications-list-iframe.component";
import * as i4 from "../../shared/oe-app.service";
import * as i5 from "../../shared/oe-app-person.service";
import * as i6 from "../../shared/notification.service";
import * as i7 from "./notifications-list-page.component";
var styles_NotificationsListPageComponent = [i0.styles];
var RenderType_NotificationsListPageComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_NotificationsListPageComponent, data: {} });
export { RenderType_NotificationsListPageComponent as RenderType_NotificationsListPageComponent };
export function View_NotificationsListPageComponent_0(_l) { return i1.ɵvid(2, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "lp2-notifications-list-iframe", [], null, null, null, i2.View_NotificationsListIframeComponent_0, i2.RenderType_NotificationsListIframeComponent)), i1.ɵdid(1, 180224, null, 0, i3.NotificationsListIframeComponent, [i4.OeAppService, i5.OeAppPersonService, i6.NotificationService], null, null)], null, null); }
export function View_NotificationsListPageComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "lp2-notifications-list-page", [], null, null, null, View_NotificationsListPageComponent_0, RenderType_NotificationsListPageComponent)), i1.ɵdid(1, 49152, null, 0, i7.NotificationsListPageComponent, [], null, null)], null, null); }
var NotificationsListPageComponentNgFactory = i1.ɵccf("lp2-notifications-list-page", i7.NotificationsListPageComponent, View_NotificationsListPageComponent_Host_0, {}, {}, []);
export { NotificationsListPageComponentNgFactory as NotificationsListPageComponentNgFactory };
//# sourceMappingURL=notifications-list-page.component.ngfactory.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/notifications-list/notifications-list-page/notifications-list-page.component.ngfactory.js
// module id = 1750
// module chunks = 27 28 29